import React from 'react';
import './style.css';
import Row from './Row/';

export default class extends React.PureComponent {
    render() {
        if (this.props.rows.length === 0) {
            return <div className="TableEditor"><p>Ingen data</p></div>;
        }

        const otherHeaders = Object.keys(this.props.rows[0].other);
        const researchActivityHeaders = this.props.rows[0].researchActivities.map((value, i) => `Forskningsaktivitet ${i + 1}`);
        const healthCategoryHeaders = this.props.rows[0].healthCategories.map((value, i) => `Helsekategori ${i + 1}`);
        const headers = [ ...otherHeaders, ...researchActivityHeaders, ...healthCategoryHeaders ];

        return <div className="TableEditor">
            <table className="TableEditor-table">
                <thead className="TableEditor-header">
                    <tr>
                        <th>Status</th>
                        { headers.map((header, i) => <th key={i}>{header}</th>) }
                    </tr>
                </thead>
                <tbody className="TableEditor-body">
                    {
                        this.props.rows.map((row, i) => <Row
                            otherHeaders={otherHeaders}
                            rowIndex={i}
                            row={row}
                            key={i}
                            updateResearchActivity={this.props.updateResearchActivity}
                            updateHealthCategory={this.props.updateHealthCategory}
                        />)
                    }
                </tbody>
            </table>
        </div>
    }
}



// WEBPACK FOOTER //
// ./src/HrcsEditor/TableEditor/index.js